export type W47BaseAlloy = { alloy: string; group: 1 | 2 | 3 | 4 | 5 };
export type W47FillerAlloy = { alloy: string; group: 1 | 2 | 3; family: "1xxx" | "4xxx" | "5xxx" };

// CSA W47.2 Table 1 - Base-metal alloy groupings, supplied from the user's standard table.
export const W47_BASE_ALLOYS: W47BaseAlloy[] = [
  { alloy: "1050", group: 1 },
  { alloy: "1060", group: 1 },
  { alloy: "1100", group: 1 },
  { alloy: "1350", group: 1 },
  { alloy: "3003", group: 1 },
  { alloy: "3004", group: 2 },
  { alloy: "5005", group: 2 },
  { alloy: "5052", group: 2 },
  { alloy: "5154", group: 2 },
  { alloy: "5254", group: 2 },
  { alloy: "5454", group: 2 },
  { alloy: "5083", group: 3 },
  { alloy: "5086", group: 3 },
  { alloy: "5383", group: 3 },
  { alloy: "5456", group: 3 },
  { alloy: "6005", group: 4 },
  { alloy: "6061", group: 4 },
  { alloy: "6063", group: 4 },
  { alloy: "6101", group: 4 },
  { alloy: "6351", group: 4 },
  { alloy: "7004", group: 5 },
  { alloy: "7005", group: 5 },
];

// CSA W47.2 Table 2 - Filler-metal alloy groupings, supplied from the user's standard table.
export const W47_FILLER_ALLOYS: W47FillerAlloy[] = [
  { alloy: "5183", group: 1, family: "5xxx" },
  { alloy: "5356", group: 1, family: "5xxx" },
  { alloy: "5554", group: 1, family: "5xxx" },
  { alloy: "5556", group: 1, family: "5xxx" },
  { alloy: "5654", group: 1, family: "5xxx" },
  { alloy: "4043", group: 2, family: "4xxx" },
  { alloy: "4047", group: 2, family: "4xxx" },
  { alloy: "4145", group: 2, family: "4xxx" },
  { alloy: "1100", group: 3, family: "1xxx" },
];

export const baseGroupForAlloy = (alloy: string) => W47_BASE_ALLOYS.find(x => x.alloy === alloy)?.group ?? null;
export const fillerForAlloy = (alloy: string) => W47_FILLER_ALLOYS.find(x => x.alloy === alloy) ?? null;

// CSA W47.2 Clauses 11.6.1 to 11.6.3 - GMAW electrode alloy qualification coverage.
// Group 1 (5xxx) qualifies Groups 1 and 2. Group 2 does not qualify Group 1.
// Groups 2 (4xxx) and 3 (1xxx) qualify only within their own group.
export const qualifiedFillerGroups = (testedGroup: 1 | 2 | 3 | null | undefined): Array<1 | 2 | 3> => {
  if (testedGroup === 1) return [1, 2];
  if (testedGroup === 2) return [2];
  if (testedGroup === 3) return [3];
  return [];
};

export const fillerGroupCovered = (testedGroup: 1 | 2 | 3 | null | undefined, requiredGroup: 1 | 2 | 3 | null | undefined) =>
  requiredGroup != null && qualifiedFillerGroups(testedGroup).includes(requiredGroup);

export const qualifiedFillerAlloys = (testedGroup: 1 | 2 | 3 | null | undefined) => {
  const groups = qualifiedFillerGroups(testedGroup);
  return W47_FILLER_ALLOYS.filter(item => groups.includes(item.group));
};
